import React from "react";
import "@/App.css";
import { LanguageProvider } from "@/components/LanguageContext";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Services } from "@/components/Services";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <Header />
        <Hero />
        <About />
        <Services />
        <Contact />
        <Footer />
        <Toaster position="top-center" />
      </div>
    </LanguageProvider>
  );
}

export default App;
